import { useState, useEffect } from "react";
import { toast } from "sonner";
import api from "../lib/api";

const STATUSES = ["nieuw", "gecontacteerd", "demo gepland", "afgerond"];

const downloadReport = async (r) => {
  try {
    const { data } = await api.get(`/demo-requests/${r.id}/report.pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `VSM-test-${r.organization}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  } catch {
    toast.error("Rapport maken mislukt");
  }
};

function VsmResult({ r }) {
  const [open, setOpen] = useState(false);
  const s = r.vsm_scores || {};
  const msgs = r.messages || [];
  return (
    <div className="md:col-span-3 space-y-2" data-testid={`demo-vsm-${r.id}`}>
      <div className="flex flex-wrap items-center gap-4 text-xs">
        <span className="font-mono uppercase tracking-widest text-zinc-500">VSM-test {r.vsm_status?.klaar ? "afgerond" : r.vsm_status?.vraag ? `${r.vsm_status.vraag}/20` : msgs.length ? "gestart" : "niet gestart"}</span>
        {["s1", "s2", "s3", "s4", "s5"].map((k, i) => (
          <span key={k} className="flex items-center gap-1.5" data-testid={`demo-vsm-score-${r.id}-${k}`}>
            <span className="font-mono">S{["I", "II", "III", "IV", "V"][i]}</span>
            <span className="w-16 h-1.5 bg-zinc-100"><span className="block h-full bg-zinc-900" style={{ width: `${(s[k] ?? 0) * 100}%` }} /></span>
            <span className="tabular-nums">{s[k] !== undefined ? `${Math.round(s[k] * 100)}%` : "–"}</span>
          </span>
        ))}
        {msgs.length > 0 && <button onClick={() => setOpen(!open)} className="underline underline-offset-4" data-testid={`demo-vsm-toggle-${r.id}`}>{open ? "Verberg gesprek" : `Toon gesprek (${msgs.length})`}</button>}
        {r.vsm_scores && <button onClick={() => downloadReport(r)} className="underline underline-offset-4" data-testid={`demo-vsm-pdf-${r.id}`}>Rapport (PDF)</button>}
      </div>
      {open && (
        <div className="max-h-96 overflow-y-auto border border-zinc-200 p-3 space-y-2 text-sm bg-zinc-50" data-testid={`demo-vsm-transcript-${r.id}`}>
          {msgs.map((m, i) => (
            <p key={i} className="whitespace-pre-wrap"><span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mr-2">{m.role === "assistant" ? "Robin" : r.name}</span>{m.text.replace(/\*\*/g, "").replace(/^#{1,6}\s*/gm, "")}</p>
          ))}
        </div>
      )}
    </div>
  );
}

export const DemoRequestsTab = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/demo-requests").then(({ data }) => setItems(data), () => {
      toast.error("Demo-aanvragen laden mislukt");
      setItems([]);
    });
  }, []);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/demo-requests/${id}`, { status });
      setItems((xs) => xs.map((x) => (x.id === id ? { ...x, status } : x)));
      toast.success("Status bijgewerkt");
    } catch {
      toast.error("Status bijwerken mislukt");
    }
  };

  if (!items) return <p className="text-sm text-zinc-500">Laden…</p>;
  if (!items.length) return <p className="text-sm text-zinc-400" data-testid="demo-requests-empty">Nog geen demo-aanvragen.</p>;
  return (
    <div className="divide-y divide-zinc-200 border-y border-zinc-900" data-testid="demo-requests-list">
      {items.map((r) => (
        <div key={r.id} className="py-4 grid md:grid-cols-[1fr_1fr_auto] gap-3 items-start" data-testid={`demo-request-${r.id}`}>
          <div>
            <div className="font-grotesk font-semibold">{r.organization}</div>
            <div className="text-xs font-mono text-zinc-500">{new Date(r.created_at).toLocaleString("nl-NL")} · {r.system_label}</div>
          </div>
          <div className="text-sm">
            <div className="font-medium">{r.name} <span className="text-zinc-500 font-normal">· {r.function}</span></div>
            <a href={`mailto:${r.email}`} className="block text-zinc-600 underline underline-offset-4">{r.email}</a>
            <a href={`tel:${r.phone}`} className="block text-zinc-600">{r.phone}</a>
          </div>
          <select value={r.status} onChange={(e) => setStatus(r.id, e.target.value)} className="border border-zinc-900 px-2 py-1.5 text-sm bg-white" data-testid={`demo-request-status-${r.id}`}>
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <VsmResult r={r} />
        </div>
      ))}
    </div>
  );
};
